import { mergeClasses, Image } from '@fluentui/react-components';

import CardBackgroundContent from 'src/components/atoms/card-background-content/CardBackgroundContent';
import CardLayoutContainer from 'src/components/molecules/card-layout-container/CardLayoutContainer';
import { BaseCardLayoutProps } from 'src/ui-models/cardLayout';
import { useCardTextOnlyLayoutStyles } from './CardTextOnlyLayout.styles';

interface CardTextOnlyLayoutProps extends BaseCardLayoutProps {
  iconUrl?: string
  color?: string
}

const CardTextOnlyLayout: React.FC<CardTextOnlyLayoutProps> = ({ iconUrl, color, headline, body, className }) => {
  const styles = useCardTextOnlyLayoutStyles();
  const iconRender = iconUrl && (
    <Image alt="Card icon" src={iconUrl} className={styles.icon} role="presentation" data-testid="text-only-icon" />
  );
  const cardHeader = color && (
    <div data-testid="text-only-top-color" className={styles.topColor} style={{ background: color }}></div>
  );

  return (
    <CardLayoutContainer className={mergeClasses('card-text-only-layout', className)} header={cardHeader}>
      {iconRender}
      <CardBackgroundContent headline={headline} body={body} />
    </CardLayoutContainer>
  );
};

export default CardTextOnlyLayout;
